import { render, staticRenderFns } from "./CardLivenessHistory.vue?vue&type=template&id=b850ecae&scoped=true"
import script from "./CardLivenessHistory.vue?vue&type=script&lang=js"
export * from "./CardLivenessHistory.vue?vue&type=script&lang=js"
import style0 from "./CardLivenessHistory.vue?vue&type=style&index=0&id=b850ecae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850ecae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b850ecae')) {
      api.createRecord('b850ecae', component.options)
    } else {
      api.reload('b850ecae', component.options)
    }
    module.hot.accept("./CardLivenessHistory.vue?vue&type=template&id=b850ecae&scoped=true", function () {
      api.rerender('b850ecae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHiveDetail/components/CardLivenessHistory.vue"
export default component.exports